/* eslint-disable object-curly-spacing */
/* eslint-disable no-undef */
/* eslint-disable own-handles */
/* eslint-disable no-innerhtml-assign */
/* eslint-disable consistent-method-names */
/* eslint-disable no-jsdoc */
define(['./template'], function(template) {

    function createKeyValueString(key, value) {
        return encodeURIComponent(key) + '=' + encodeURIComponent(value);
    }

    function mapQueryParamToKeyValueString(key, queryParams) {
        var queryParamValue = queryParams[key];
        var result = '';
        if (Array.isArray(queryParamValue)) {
            result = queryParamValue.map(function(value) {
                return createKeyValueString(key, value);
            }).join('&');
        } else {
            result = createKeyValueString(key, queryParams[key]);
        }
        return result;
    }

    function withQueryParams(url, queryParams) {
        var queryString;
        if (!queryParams) {
            return url;
        }

        queryString = Object.keys(queryParams)
            .map(function(key) {
                return mapQueryParamToKeyValueString(key, queryParams);
            })
            .join('&');
        return url + '?' + queryString;
    }

    return function(urlTemplate, pathParams, queryParams) {
        var url = template(urlTemplate, pathParams);
        return withQueryParams(url, queryParams);
    };
});



// WEBPACK FOOTER //
// ./requester/urlBuilder.js